<!-- record contact dialog dialog -->
<kendo-dialog *ngIf="contactHistoryDialogOpened" title="{{'RECORD-CONTACT' | translate}}" [width]="820"
  (close)="cancelContactHistory()">
  <ng-template [ngIf]="hasTask()" [ngIfElse]="showMemberText">
    {{'CONFIRM-COMPLETE-TASK' | translate}}
  </ng-template>
  <ng-template #showMemberText>
  </ng-template>
  <form [formGroup]="contactHistoryForm" class="k-form" (ngSubmit)="createContactHistory()" style="max-height:600px">
    <!--Contact Method-->
    <div class="row mt-2 mb-2" *ngIf="showMethod">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-METHOD' | translate}} {{requiredMethod === true ? '*' : ''}}
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-combobox id="contactMethod" formControlName="contactMethod" [data]="contactMethods"
          [textField]="'displayName'" [valueField]="'id'" class="w-100">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactMethod.invalid && contactMethod.touched">
          {{'CONTACT-METHOD-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Contact Entity-->
    <div class="row mt-2 mb-2" *ngIf="showEntity">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-ENTITY' | translate}} {{requiredEntity === true ? '*' : ''}}
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-combobox id="contactEntity" formControlName="contactEntity" [data]="contactEntities"
          [textField]="'displayName'" [valueField]="'id'" class="w-100">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactEntity.invalid && contactEntity.touched">
          {{'CONTACT-ENTITY-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Contact Consent-->
    <div class="row mt-2 mb-2" *ngIf="showConsent && !systemGenerated">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-CONSENT' | translate}} {{requiredConsent === true ? '*' : ''}}
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-combobox id="contactConsent" formControlName="contactConsent" [data]="contactConsents"
          [textField]="'displayName'" [valueField]="'id'" class="w-100">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactConsent.invalid && contactConsent.touched">
          {{'CONTACT-CONSENT-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Contact Activities-->
    <div class="row mt-2 mb-2" *ngIf="showActivities && !systemGenerated">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-ACTIVITIES' | translate}} {{requiredActivities === true ? '*' : ''}}
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-multiselect id="contactActivities" [data]="contactActivitiesFiltered" formControlName="contactActivities"
          [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
          (filterChange)="filterContactActivities($event)" (close)="searchTerm=''" [autoClose]="true"
          [virtual]="virtualContactActivities">
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text"> </span>
          </ng-template>
        </kendo-multiselect>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactActivities.invalid && contactActivities.touched">
          {{'CONTACT-ACTIVITY-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Contact Focus Areas-->
    <div class="row mt-2 mb-2" *ngIf="allContactAreas.length > 0">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-AREAS' | translate}} *
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-multiselect id="contactAreas" [data]="contactAreasFiltered" formControlName="contactAreas"
          [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
          (filterChange)="filterContactAreas($event)" (close)="searchTerm=''" [autoClose]="true"
          [virtual]="virtualContactAreas">
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text"> </span>
          </ng-template>
        </kendo-multiselect>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactAreas.invalid && contactAreas.touched">
          {{'CONTACT-HISTORY-AREAS-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Contact Initiative-->
    <div class="row mt-2 mb-2" *ngIf="contactInitiatives.length > 0">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-INITIATIVE' | translate}} *
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-combobox id="contactInitiative" formControlName="contactInitiative" [data]="contactInitiatives"
          [textField]="'displayName'" [valueField]="'id'" class="w-100">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactInitiative.invalid && contactInitiative.touched">
          {{'CONTACT-HISTORY-INITIATIVE-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Contact Intensity-->
    <div class="row mt-2 mb-2" *ngIf="showIntensity && !systemGenerated">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-INTENSITY' | translate}} {{requiredIntensity === true ? '*' : ''}}
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-combobox id="contactIntensity" formControlName="contactIntensity" [data]="contactIntensities"
          [textField]="'displayName'" [valueField]="'id'" class="w-100">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName }}
          </ng-template>
        </kendo-combobox>
        <div class="k-tooltip k-tooltip-validation mb-2" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactIntensities.invalid && contactIntensities.touched">
          {{'CONTACT-HISTORY-INTENSITY-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Patient Mood-->
    <div class="row mt-3" *ngIf="showMood && !systemGenerated">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACT-HISTORY-PATIENT-MOOD' | translate:patientLabel}} {{requiredMood === true ? '*' : ''}}
          </span>
        </label>
      </div>
      <div class="col-sm-8 contact-history-icons d-flex" style="font-size: smaller">
        <a *ngFor="let item of patientMoods" class="contact-mood-{{item.value}}" style="width:16%;"
          [ngClass]="{'contact-option-selected': item.value === patientMood.value}"
          (click)="selectPatientMood(item.value)">
          <input class="d-none" formControlName="patientMood" />
          <i class="far {{item.icon}} fa-2x"></i><br />
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
    <!--Contacted on-->
    <div class="row mt-3">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'CONTACTED-ON' | translate}} *
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <kendo-datetimepicker style="width: 100%;" [min]="minCO" [max]="maxCO" formControlName="contactedOn">
        </kendo-datetimepicker>
        <div class="k-tooltip k-tooltip-validation" role="alert" style="display:inline-block;position: static;"
          *ngIf="contactedOn.invalid && contactedOn.touched">{{'CONTACTED-ON-REQUIRED' | translate}}
        </div>
      </div>
    </div>
    <!--Comments-->
    <div class="row mt-3" style="max-height: 150px;">
      <div class="col-sm-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'SUMMARY' | translate}}
          </span>
        </label>
      </div>
      <div class="col-sm-8">
        <textarea kendoTextArea rows="3" class="w-100" formControlName="comments"
          [readonly]="systemGenerated"></textarea>
      </div>
    </div>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelContactHistory()">{{ (systemGenerated ? 'CLOSE' : 'CANCEL') |
      translate}}</button>
    <button appPreventClick kendoButton (click)="createContactHistory()" [primary]="true"
      [disabled]="contactHistoryForm.invalid || !contactHistoryForm.dirty" *ngIf="!systemGenerated">
      {{ (hasTask() ? 'COMPLETE-TASK' : 'SAVE') | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>